export default "__VITE_ASSET__mVpkg$4s__"